import { Avatar } from '../atoms/Avatar.js';

interface ChatBubbleProps {
  role: 'user' | 'ai';
  content: string;
  timestamp?: string;
  typing?: boolean;
}

export function ChatBubble({ role, content, timestamp, typing = false }: ChatBubbleProps) {
  const isUser = role === 'user';

  return (
    <div className={`flex gap-3 animate-fade-slide-up ${isUser ? 'flex-row-reverse' : 'flex-row'}`}>
      <Avatar
        src={isUser ? undefined : '/operator-avatar.svg'}
        alt={isUser ? '' : 'Interviewer'}
        fallback={isUser ? 'You' : 'AI'}
        size="sm"
        className={isUser ? 'bg-neutral-200 text-neutral-600' : ''}
      />
      <div
        className={`max-w-[75%] rounded-2xl px-4 py-3 ${
          isUser ? 'bg-primary-600 text-white' : 'bg-neutral-100 text-neutral-800'
        }`}
      >
        {typing ? (
          <TypingDots />
        ) : (
          <p className="whitespace-pre-wrap text-sm leading-relaxed">{content}</p>
        )}
        {timestamp && !typing && (
          <time
            className={`mt-1 block text-xs ${isUser ? 'text-primary-200' : 'text-neutral-400'}`}
          >
            {timestamp}
          </time>
        )}
      </div>
    </div>
  );
}

function TypingDots() {
  return (
    <div className="flex items-center gap-1 py-1" aria-label="Typing">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="inline-block h-2 w-2 animate-bounce rounded-full bg-neutral-400"
          style={{ animationDelay: `${i * 150}ms` }}
        />
      ))}
    </div>
  );
}
